import React from 'react';
import './positionCard.css';
import { Link } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import Typography from '@material-ui/core/Typography';

class PositionCard extends React.Component {
  render() {
    const { position } = this.props;
    return (
      <div>
        <Link to={`/positions/${position.key}`}>
          <Card className='position-card' flexWrap='nowrap' align='center'>
            <CardActionArea>
              <CardContent className='position-content'>
                <img className='cardImage' src={position.thumbnailUrl} alt={position.title} />
                <Typography className='position-card-title'>{position.thumbnail}</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Link>
      </div>
    );
  }
}

export default PositionCard;
